// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30N97","buttons":"styles_buttons__1Rqng"};